//GeneratorFlag:[NoChange]
import Discount from './discount';
import DiscountFilter from './discount-filter';

export default {Discount, DiscountFilter}
export{Discount, DiscountFilter}